import React from 'react'
import renderHTML from 'react-render-html'

const BkFlowPolicyViewerContent = props => {
  const {
    configData,
    policies,
    currentPolicy
  } = props

  const hotelLabels = configData.hotel.labels[0]
  let renderContent = []

  for (const policyKey in policies)  {
    if (policies[policyKey].content) {
      renderContent.push(
        <div
          key={ policyKey }
          className={ policyKey === currentPolicy ? 'bk-flow__policy-viewer-entry active' : 'bk-flow__policy-viewer-entry' }
        >
          { renderHTML(policies[policyKey].content) }
        </div>
      )
    }
  }

  return (
    <div className="bk-flow__policy-viewer-content">
      <h3>{ hotelLabels.hotelPolicies ? hotelLabels.hotelPolicies : 'Hotel Policies' }</h3>
      { renderContent }
    </div>
  )
}

export default BkFlowPolicyViewerContent



// WEBPACK FOOTER //
// ./src/components/policies/elements/BkFlowPolicyViewerContent.js